// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /so/combos/get/{id} — `dados` E a linha.
 */
import type { Combos_ComboRow } from './Combos_ComboRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Combos_GetResponseDados = Combos_ComboRow;

export type Combos_GetResponse = ApiResponse<Combos_GetResponseDados>;

registerResponseContract('Combos_GetResponse', {
  so_combo_id:            { type: 'number',  required: true },
  so_combo_name:          { type: 'string',  required: false },
  so_combo_service_id:    { type: 'number',  required: false },
  so_combo_priority_id:   { type: 'number',  required: false },
  so_combo_quantity:      { type: 'number',  required: false },
  so_combo_validity_days: { type: 'number',  required: false },
  so_combo_active:        { type: 'number',  required: false },
  so_combo_created_at:    { type: 'string',  required: false },
  so_service_name:        { type: 'string',  required: false },
  so_priority_name:       { type: 'string',  required: false },
})
